import React, { Fragment } from 'react';

const MapBox = () => {
  return <Fragment></Fragment>;
};

export default MapBox;
